<template>
    <alert-modal
        @close="close"
        @cancel="close"
        @overlayClick="close"
        class="cz2__discreet-modal"
    >
        <div>
            <div
                class="cz2__discreet-image"
            />

            <h1 class="cz2__discreet-title">
                {{$t('DISCREET_TOOLTIP_TITLE')}}
            </h1>

            <p class="cz2__discreet-copy">
                {{$t('DISCREET_TOOLTIP_COPY')}}
            </p>

            <btn
                primary
                @click="addDiscreetPackaging"
            >
                {{$t('DISCREET_TOOLTIP_CTA')}}{{ priceFormatted }}
            </btn>
        </div>
    </alert-modal>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__discreet-modal {
            font-family: "Proxima Nova";

            .cz2__modal-popup__body {
                max-width: 432px;
                overflow: hidden;
            }

            .cz2__discreet-image {
                margin: 0 auto;
                width: 100%;
                aspect-ratio: 5/4;
                background-position: center;
                background-size: contain;
                background-repeat: no-repeat;
                background-image: url(../assets/images/discreet-packaging-placeholder.webp);
            }

            .cz2__discreet-title {
                margin-top: 24px;
                margin-bottom: 8px;
                @include font(feature);
                font-size: 32px;
                font-style: italic;
            }

            .cz2__btn {
                margin-top: 24px;
                margin-bottom: 8px;
                width: 100%;
                height: 48px;

                // Override global focus styles that cause unwanted scrollbars
                &:hover,
                &:focus {
                    font-size: 18px !important;
                }

                &:focus {
                    &:before {
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                    }
                }
            }

            @include respond-above(lg) {
                .cz2__discreet-copy {
                    font-size: 20px;
                }
            }
        }
    }
</style>

<script>
    import Btn from './ui/Btn.vue';
    import AlertModal from './ui/AlertModal.vue';

    import * as constants from '../constants';

    import { formatPrice } from '../helpers/formatPrice';

    export default {
        components: {
            Btn,
            AlertModal,
        },

        data() {
            return {
            };
        },

        computed: {
            viewController() {
                return this.$store.state.customizer.viewController;
            },

            mainController() {
                return this.$store.state.customizer.mainController;
            },

            priceFormatted() {
                return ` + ${this.discreetBoxPrice}`;
            },

            availablePackaging() {
                return this.$store.getters.availablePackaging;
            },

            discreetBoxPrice() {
                const component = this.availablePackaging;
                let price = 0;

                if (component == null) {
                    return price;
                }

                if (component.price != null) {
                    price = component.price[0].value;
                }

                price = this.mainController.getPrice(this.availablePackaging);

                return this.formatPriceValue(price);
            },
        },

        methods: {
            addDiscreetPackaging() {
                if (this.availablePackaging) {
                    this.$store.dispatch('log', {
                        level: 'info',
                        message: 'Add packaging',
                    });

                    this.$store.dispatch('bumpVersion');

                    this.mainController.updateComponent(constants.PLACEMENT_DISCREET_PACKAGING, this.availablePackaging.code);
                }

                this.close();
            },

            close() {
                this.$store.dispatch('showDiscreetPackagingModal', false);
            },

            formatPriceValue(price) {
                return formatPrice(this.$store.state, price, 'standard');
            },
        },
    };
</script>
